import React from "react"
import Container from "../Container"
import quality_image1 from "../../images/home/quality/quality_image1.png"
import quality_image2 from "../../images/home/quality/quality_image2.png"
import { navigate } from "gatsby"

function Quality() {
  return (
    <Container>
      <div className="mb-[268px]">
        <p className="uppercase text-[24px] w-[80%] lg:text-[40px] lg:w-[800px] font-[700] leading-[34px] lg:leading-[68px]">
          Your Roofing Experts with a Commitment to Quality
        </p>
        <div className="flex flex-col lg:flex-row gap-[24px] lg:gap-[70px] ">
          <div className="w-full lg:w-[60%] pt-10">
            <p className=" text-[16px] mb-[32px] w-full font-[400] text-[#222222] leading-[24px]">
              With a foundation of experience and dedication, we specialize in
              delivering exceptional roofing services.
            </p>
            <div className="w-full">
              <img className="w-full" src={quality_image1} alt="" />
            </div>
          </div>
          <div className="w-full lg:w-[40%]">
            <div className="w-full mb-[51px]">
              <img className="w-full" src={quality_image2} alt="" />
            </div>
            <p className=" text-[16px] w-full font-[400] text-[#222222] leading-[24px]">
              Our team of skilled professionals is passionate about ensuring
              your home is protected with the highest quality materials and
              craftsmanship. We pride ourselves on our customer-focused
              approach, striving to exceed your expectations every step of the
              way.
            </p>
            <p
              onClick={() => navigate("/services")}
              className="font-[500] cursor-pointer text-[#1255BA] mt-[40px]  text-[16px] lg:text-[20px]"
            >
              LEARN MORE
            </p>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Quality
